export const URL = "/rails/active_storage/direct_uploads"

export const MAX_FILE_SIZE_MB = 10

export enum FileStatus {
  Idle = "IDLE",
  Uploading = "UPLOADING",
  Uploaded = "UPLOADED",
  Error = "ERROR",
}

/**
 * @param bytes file size in bytes
 * @param limit file size limit in Mb, defaults to 10Mb
 */
export const isFileOverSize = (bytes: number, limit: number) => {
  return bytes / 1024 ** 2 > limit
}
